{
  "version": 1,
  "asset_id": "417bf3da-8750-49c7-8049-0ea36df5aa05",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/417bf3da-8750-49c7-8049-0ea36df5aa05/svc-local-seo-1200.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/417bf3da-8750-49c7-8049-0ea36df5aa05/svc-local-seo-1200.avif",
  "original_filename": "svc-local-seo-1200.avif",
  "size": 11299,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:54Z"
}
